var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9631 6.28666C15.732 4.74221 14.4163 3.64157 12.9228 3.57056C13.2962 2.18588 14.203 1.63556 15.3053 1.31602C15.412 1.28051 15.3942 1.174 15.3942 1.174L15.2164 0.0733566C15.2164 0.0733566 15.1986 -0.0154049 15.0564 0.00234741C11.2515 0.428403 8.67347 3.32203 9.15353 6.83698C9.59802 9.26905 11.5004 10.2099 13.2606 9.96139C15.0208 9.67735 16.2298 8.04414 15.9631 6.28666ZM3.81962 3.57056C4.17522 2.18588 5.11754 1.63556 6.2021 1.31602C6.30878 1.28051 6.291 1.174 6.291 1.174L6.13098 0.0733566C6.13098 0.0733566 6.1132 -0.0154049 5.97097 0.00234741C2.14834 0.428403 -0.394157 3.32203 0.0503349 6.83698C0.512606 9.26905 2.43281 10.2099 4.17522 9.96139C5.93541 9.67735 7.14442 8.04414 6.85995 6.28666C6.62881 4.72446 5.3309 3.62382 3.81962 3.57056Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.e37be764bbd27e6e0f935693421a2072.svg";
export { ForwardRef as ReactComponent };